/**
 * Sentry frontend initialization.
 *
 * No-op when VITE_SENTRY_DSN is not set (local dev / CI without secret).
 * Call initSentry() once before React mount in main.tsx.
 *
 * Gates closed by this module:
 *   #5 — Sentry error rate < 0.5% (requires DSN in prod env)
 *   #6 — 0 console.error in prod build (console.error wrapped in DEV checks)
 */
import * as Sentry from '@sentry/react';

export function initSentry(): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_APP_VERSION ?? 'dev',
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0.1,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: true, blockAllMedia: false }),
    ],
  });
}

export const SentryErrorBoundary = Sentry.ErrorBoundary;
export const captureException = Sentry.captureException;
